
import { useState, useEffect } from "react";
import { Navbar } from "@/components/LandingPage/Navbar";
import { Hero } from "@/components/LandingPage/Hero";
import { FeatureRow } from "@/components/LandingPage/FeatureRow";
import { ProductGrid, ImmersiveSection } from "@/components/LandingPage/FeatureComponents";
import { TaxiFusionCTA } from "@/components/LandingPage/TaxiFusionCTA";
import { InstallationSection } from "@/components/LandingPage/InstallationSection";
import { ContactForm } from "@/components/LandingPage/ContactForm";
import { FeatureGrid, Footer } from "@/components/LandingPage/FooterSection";
import { Impressum } from "@/components/LandingPage/Impressum";
import { InstallationPage } from "@/components/LandingPage/InstallationPage";
import featureImage from "@/assets/feature-main.webp";

export function App() {
  const [showImpressum, setShowImpressum] = useState(false);
  const [showInstallation, setShowInstallation] = useState(false);

  useEffect(() => {
    if (window.location.hash === "#impressum") {
      setShowImpressum(true);
      setShowInstallation(false);
    } else if (window.location.hash === "#installation") {
      setShowInstallation(true);
      setShowImpressum(false);
    } else {
      setShowImpressum(false);
      setShowInstallation(false);
    }

    const handleHashChange = () => {
      if (window.location.hash === "#impressum") {
        setShowImpressum(true);
        setShowInstallation(false);
      } else if (window.location.hash === "#installation") {
        setShowInstallation(true);
        setShowImpressum(false);
      } else {
        setShowImpressum(false);
        setShowInstallation(false);
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const handleImpressumClose = () => {
    setShowImpressum(false);
    window.history.pushState("", document.title, window.location.pathname);
  };

  const handleInstallationClose = () => {
    setShowInstallation(false);
    window.history.pushState("", document.title, window.location.pathname);
  };

  if (showImpressum) {
    return <Impressum onClose={handleImpressumClose} />;
  }

  if (showInstallation) {
    return <InstallationPage onClose={handleInstallationClose} />;
  }

  return (
    <div className="min-h-screen text-white selection:bg-white/20 overflow-x-hidden">
      <Navbar />

      <main>
        <Hero />

        <FeatureRow
          title="Zuverlässigkeit für Ihr Taxiunternehmen"
          description="Die TBOX wurde speziell für den professionellen Taxibetrieb entwickelt. Maximale Zuverlässigkeit und einfache Bedienung für Ihre TSE-Compliance – Tag für Tag."
          features={[
            "Sofort einsatzbereit nach Installation",
            "Zuverlässig für den täglichen Betrieb",
            "Einfache Bedienung ohne technisches Know-how"
          ]}
          imageSrc={featureImage}
        />
        <ProductGrid />

        <TaxiFusionCTA />

        <InstallationSection />

        <ImmersiveSection />

        <ContactForm />

      </main>

      <Footer />
    </div>
  );
}

export default App;
